import React from 'react';
import Select from 'react-draggable-multi-select';

//Sortable multi select input
const SortableSelect = ({ value, onChange, options, isMultiSelect = true }) => (
  <Select
    value={value}
    onChange={onChange}
    options={options}
    isMulti={isMultiSelect}
    closeMenuOnSelect={false}
  />
);

export default SortableSelect;
